import { z } from 'zod';
import { Timestamp } from './common';
import { endpoint } from './endpoint';
import { lenientArray } from './lenient';

/** One installer from the provider's signed release metadata, as the company server verified it (P02). */
export const DesktopReleaseFile = z.object({
  os: z.enum(['windows', 'macos', 'linux']),
  /** CPU. */
  arch: z.enum(['x64', 'arm64']),
  format: z.enum(['exe', 'dmg', 'zip', 'deb', 'rpm', 'appimage']),
  version: z.string().min(1).max(64),
  name: z.string().min(1).max(255),
  /** The provider's download address (https). */
  url: z.url(),
  sha256: z.string().regex(/^[0-9a-f]{64}$/),
  size: z.number().int().nonnegative(),
});
export type DesktopReleaseFile = z.infer<typeof DesktopReleaseFile>;

/**
 * GET /api/v1/releases/desktop — what the download page offers. A newer
 * server may list installers for an OS, CPU or format this app does not know;
 * those entries are skipped.
 */
export const DesktopReleases = z.object({
  /** The provider's own download page, offered when nothing is verified here. */
  officialUrl: z.url(),
  /** When the company server last verified the signed metadata; null when it holds none that is current. */
  verifiedAt: Timestamp.nullable(),
  files: lenientArray(DesktopReleaseFile),
});
export type DesktopReleases = z.infer<typeof DesktopReleases>;

export const releasesEndpoints = {
  desktop: endpoint({ id: 'releases.desktop', method: 'GET', path: '/api/v1/releases/desktop', auth: 'public', response: DesktopReleases }),
};
